import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import dsteem from "../../unit/DsteemUtil";
import { extractLoginData } from "../../unit/UserUtil";
export default {
  props: {
    isShowText: {
      type: Boolean,
      "default": true
    },
    userName: {
      type: String,
      "default": ""
    },
    permlink: {
      type: String,
      "default": ""
    }
  },
  data: function data() {
    return {
      isReSteem: false,
      loginData: null
    };
  },
  computed: {},
  methods: {
    resteem: function resteem() {
      dsteem.resteem(this.userName, this.permlink);
      this.isReSteem = true;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var dataJson, dataList;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loginData = extractLoginData();
              dataJson = localStorage.getItem("resteem");
              dataList = JSON.parse(dataJson);
              _this.isReSteem = _this.loginData && dataList && dataList.filter(function (item) {
                return item.userName === _this.loginData[0] && item.author == _this.userName && item.permlink == _this.permlink;
              }).length >= 1;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};